<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M14.5,0C14.5,0,1.5,0,1.5,0C0.67,0,0,0.67,0,1.5C0,2.33,0.67,3,1.5,3C1.5,3,7,3,7,3C7,3,7,6,7,6C7,6,3.5,6,3.5,6C2.67,6,2,6.67,2,7.5C2,8.33,2.67,9,3.5,9C3.5,9,7,9,7,9C7,9,7,12,7,12C7,12,5.5,12,5.5,12C4.67,12,4,12.67,4,13.5C4,14.33,4.67,15,5.5,15C5.5,15,10.5,15,10.5,15C11.33,15,12,14.33,12,13.5C12,12.67,11.33,12,10.5,12C10.5,12,9,12,9,12C9,12,9,9,9,9C9,9,12.5,9,12.5,9C13.33,9,14,8.33,14,7.5C14,6.67,13.33,6,12.5,6C12.5,6,9,6,9,6C9,6,9,3,9,3C9,3,14.5,3,14.5,3C15.33,3,16,2.33,16,1.5C16,0.67,15.33,0,14.5,0C14.5,0,14.5,0,14.5,0Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Path',
} as DefineComponent
</script>
